import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
    style={{
      enableBackground: "new 0 0 45 45",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path fill={props.background}  d="M43.2 7.7c-.1-.1-.1-.2-.1-.2l-.1-.1-.1-.1h-.2l-20-5.5h-.4l-20 5.5h-.2c0 .1 0 .1-.1.2l-.1.1-.1.1v.1c0 .1-.1.2-.1.3v34.5c0 .4.3.8.8.8h40.2c.4 0 .8-.3.8-.8V8c-.2-.1-.3-.2-.3-.3zm-1.4 1.1v4H3.2v-4h38.6zM3.2 14.3h38.5v5.4H3.2v-5.4zm19.3-11 14.5 4H8l14.5-4zM11.4 34.9H6v-5.4h5.4v5.4zM6 41.8v-5.4h8.1v5.4H6zm12.4 0v-5.4h6.8v5.4h-6.8zm11.1 0v-9.5H39v9.5h-9.5zm8.1-11.1h-5.4v-4h5.4v4zm2.9 11.1V31.5c0-.4-.3-.8-.8-.8h-.6v-4.8c0-.4-.3-.8-.8-.8h-6.9c-.4 0-.8.3-.8.8v4.8h-2c-.4 0-.8.3-.8.8v10.3h-1.3v-6.1c0-.4-.3-.8-.8-.8h-8.3c-.4 0-.8.3-.8.8v6.1h-1.3v-6.1c0-.4-.3-.8-.8-.8h-2v-6.1c0-.4-.3-.8-.8-.8H5.3c-.4 0-.8.3-.8.8v13H3.2V21.2h38.5v20.6h-1.2z" />
  </svg>
)

export default SvgComponent
